var _defs, _rect, _rect2, _rect3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntrusoPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 3,
    dy: 5,
    stdDeviation: 4,
    floodColor: "#000000",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lensGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "frameGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#475569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#94A3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1E293B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "handleGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E65100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A3412"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#1E3A8A",
    opacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 20,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#1E3A8A",
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 80,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#1E3A8A",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 25,
    fill: "none",
    stroke: "#E65100",
    strokeWidth: 2,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;25",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,-15 L15,10 L-15,10 Z",
    fill: "#E65100",
    filter: "url(#drop-shadow)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 10)",
    filter: "url(#drop-shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 65,
    width: 12,
    height: 35,
    rx: 6,
    fill: "url(#handleGrad)",
    transform: "rotate(-45 71 82.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 66,
    width: 4,
    height: 33,
    rx: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    transform: "rotate(-45 71 82.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 30,
    fill: "none",
    stroke: "url(#frameGrad)",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 26,
    fill: "url(#lensGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30 Q50,20 65,35",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    opacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrusoPremium);
export default __webpack_public_path__ + "static/media/intruso_premium.1acb4511acfc6687b8144d9643bd2e04.svg";
export { ForwardRef as ReactComponent };